import { SESSION_STATUS } from "interfaces/Sessions";
import Dot, { VARIANT } from "ui/Dot";

const Status = ({ sessionStatus }: { sessionStatus: SESSION_STATUS }) => {
  switch (sessionStatus) {
    case SESSION_STATUS.STANDBY:
      return (
        <div className="flex items-center">
          <Dot variant={VARIANT.INFO} />
          <p>En espera</p>
        </div>
      );
    case SESSION_STATUS.READY:
      return (
        <div className="flex items-center">
          <Dot variant={VARIANT.SUCCESS} />
          <p>Lista para jugar</p>
        </div>
      );
    case SESSION_STATUS.IN_PROGRESS:
      return (
        <div className="flex items-center">
          <Dot variant={VARIANT.SUCCESS} />
          <p>En progreso</p>
        </div>
      );
    default:
      return <p>Disponible</p>;
  }
};

export default Status;
